import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="var(--sds--ursa-icons--inner-shape-color, transparent)"
            d="M10.7 10.391a.7.7 0 1 1-1.4 0v-3.1a.7.7 0 1 1 1.4 0zM10 13.41a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0m7 1.091a.7.7 0 0 0 .7-.7v-3.1a.7.7 0 1 0-1.4 0v3.1a.7.7 0 0 0 .7.7m-.75 1.569a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
